import { fork, all } from "redux-saga/effects"

import accountSaga from "./account"
import asyncProcessSaga from "./asyncprocess"
import itemsSaga from "./items"
import importSaga from "./import"

function* rootSaga() {
  yield all([fork(accountSaga), fork(asyncProcessSaga), fork(itemsSaga), fork(importSaga)])
}

export default rootSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js